import { ITransportationSearchStationsPayload } from '@/models/Transportation/interfaces/payloads/ITransportationSearchStationsPayload';

export interface ITransportationSearchStation {
  markedStations: ITrainStation[];
  stations: ITrainStation[];
}

export interface ITrainStation {
  code: string;
  name: string;
  isKTX: boolean;
  isMark: boolean;
}

export interface ITrainStationSuggestion {
  code: string;
  name: string;
}

export function serializeStationSearchResult(
  stationPayload: ITransportationSearchStationsPayload,
): ITransportationSearchStation {
  const markedStations = [
    {
      code: '0001',
      name: '서울',
      isKTX: true,
      isMark: true,
    },
    {
      code: '0104',
      name: '용산',
      isKTX: true,
      isMark: true,
    },
    {
      code: '0020',
      name: '부산',
      isKTX: true,
      isMark: true,
    },
    {
      code: '0010',
      name: '대전',
      isKTX: true,
      isMark: true,
    },
    {
      code: '0015',
      name: '동대구',
      isKTX: true,
      isMark: true,
    },
    {
      code: '0036',
      name: '광주송정',
      isKTX: true,
      isMark: true,
    },
    {
      code: '0508',
      name: '경주',
      isKTX: true,
      isMark: true,
    },
    {
      code: '0053',
      name: '여수EXPO',
      isKTX: true,
      isMark: true,
    },
    {
      code: '0115',
      name: '강릉',
      isKTX: true,
      isMark: true,
    },
  ];

  const stations = stationPayload.map((item) => {
    return {
      code: item.code,
      name: item.name,
      isKTX: item.ktx,
      isMark: item.mark,
    };
  });

  return {
    markedStations,
    stations,
  };
}
